import { action } from "@ember/object";
import ForcJournalEventBasedComponent from "parog-web/components/forc/abstract/journal-event-based-component";
import JournalEventRetrievalStrategies from "parog-web/components/forc/utils/journal-event-retrieval-strategies";

export default class PRFeelingEvasFormComponent extends ForcJournalEventBasedComponent {
  journalEventProperties = ["occurredAt", "feeling", "comments"];

  retrieveJournalEvent = JournalEventRetrievalStrategies.sourceJournalEvent;

  computePayload() {
    const payload = super.computePayload();
    payload.feeling = (payload.feeling as number).toFixed(2);
    payload.occurredAt = payload.occurredAt || new Date();
    return payload;
  }

  @action
  setProperty(propertyName, value) {
    this.changeset.set(propertyName, value);
  }
}
